import { call, put, takeLatest, select } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import { uploadEventsSuccess, uploadEventsFailure } from '../slices/eventUploadSlice';
import { fetchUpcomingEventsRequest } from '../slices/upcomingEventsSlice';
import { post } from '../../api/service/apiService';

import type { EventData } from '../../utils/excelParser';

function* uploadEventsSaga(action: PayloadAction<EventData[]>): Generator<any, void, any> {
  try {
    const events = action.payload;
    const restaurantId = yield select((state) => state.clover.restaurantId);

    console.log('Uploading events:', events);
    console.log('Restaurant ID:', restaurantId);

    // Upload events to the API - send array directly, not wrapped in object
    const response = yield call(post, {
      endpoint: 'https://promoflowapidev.snapmenu.ai/event-master',
      headers: {
        'restaurantid': restaurantId
      },
      body: events
    });

    console.log('Upload response:', response);

    // Success
    yield put(uploadEventsSuccess());

    // Refresh upcoming events
    yield put(fetchUpcomingEventsRequest({ restaurantId, countryCode: 'US' }));

  } catch (error: any) {
    console.error('Upload error:', error);
    // Better error handling
    let errorMessage = 'Failed to upload events';
    
    if (error?.data?.message) {
      errorMessage = error.data.message;
    } else if (error?.message) {
      errorMessage = error.message;
    } else if (error?.statusText) {
      errorMessage = `${error.status}: ${error.statusText}`;
    }
    
    yield put(uploadEventsFailure(errorMessage));
  }
}

export default function* eventUploadWatcher() {
  yield takeLatest('eventUpload/uploadEventsRequest', uploadEventsSaga);
}
